import WorkOrderTask from '../../services/workOrderTask'
import * as types from '../mutationTypes'
import store from '..'

let state = {
  error: null,
  task: null,
  // tasks
  tasks: [],
  taskPagination: {
    count: null,
    pageIndex: null,
    pageSize: null
  },
  taskLocationList: [],
  // unscheduledTasks
  unscheduledTasks: [],
  unscheduledTaskPagination: {
    count: null,
    pageIndex: null,
    pageSize: null
  },
  // archivedTasks (don't need pageSize/Index for data tables)
  archivedTasks: [],
  archivedTotal: null,
  // scheduledTasks
  scheduledTasks: [],
  scheduledTaskPagination: {
    count: null,
    startPoint: '',
    endPoint: ''
  },
  // search
  searchObject: {},
  startDates: [],
  isdDates: [],
  locations: [],
  cpaNumbers:[],
  search: null,
  taskSort: {
    sortOrder: 'isd',
    isDesc: true
  },
  headers: [
    { text: 'WO #', value: 'workOrder.workOrderNumber' },
    { text: 'Task #', value: 'taskNumber' },
    { text: 'ESO #', value: 'eso' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  error (state) {
    return state.error
  },
  headers () {
    return state.headers
  },
  selectedTask (state) {
    if (state.task) {
      //TODO: How a selectedTask in state is getting saved with no WorkOrder
      //For now checking if the workOrder is there so there's no display error
      let workOrderNumber = 'Undefined'
      if (state.task.workOrder) {
        workOrderNumber = `${state.task.workOrder.workOrderNumber}`
      }
      state.task.name = `${workOrderNumber}-${state.task.taskNumber}`
      let crews = []
      for (let i = 0; i < state.task.crewTasks.length; i++) {
        if (crews.length > 0) {
          crews.push({ text: state.task.crewTasks[i].crew.id, value: state.task.crewTasks[i].crew })
        } else {
          crews.push({ text: state.task.crewTasks[i].crew.id, value: state.task.crewTasks[i].crew })
        }
      }
      state.task.crews = crews
    }
    return state.task
  },
  selectedCrewTask(state) {
    return state.task.crewTasks.map(ct => {
      return ct
    })
  },
  selectedCrews (state) {
    return state.task.crewTasks.map(ct => {
      return ct.crew
    })
  },
  searchObject (state) {
    return state.searchObject
  },
  taskPagination (state) {
    return state.taskPagination
  },
  tasks (state) {
    return state.tasks
  },
  unscheduledTaskPagination (state) {
    return state.unscheduledTaskPagination
  },
  unscheduledTasks (state) {
    return state.unscheduledTasks
  },
  scheduledTaskPagination (state) {
    return state.scheduledTaskPagination
  },
  archivedTasks (state) {
    return state.archivedTasks
  },
  archivedTotal (state) {
    return state.archivedTotal
  },
  taskSort (state) {
    return state.taskSort
  },
  taskLocationList (state) {
    return state.taskLocationList
  },
  // Lists for search bar
  generalLocations (state) {
    return state.locations
  },
  startDates (state) {
    return state.startDates
  },
  isds (state) {
    return state.isdDates
  },
  typeToLabel (state) {
    return state.typeToLabel
  },
  listOfCPAs (state) {
    return state.cpaNumbers
  },
  // Swtich cases for task status's
  step (state) {
    if (state.task !== null) {
      switch (state.task.status) {
        case 'Initiation':
          return 1
        case 'Planning':
          return 2
        case 'Execution':
          return 3
        case 'FieldComplete':
          return 4
        case 'CloseOut':
          if (store.state.user.role !== 'Admin') {
            return 4
          } else {
            return 5
          }
      }
    } else {
      return 1
    }
  },
  selectedTaskColor (state) {
    let color = null
    if (state.task && state.task.flag === false) {
      switch (state.task.status.toLowerCase()) {
        case 'planning':
          color = '#f8da36'
          break
        case 'execution':
          color = '#2196f3'
          break
        case 'fieldcomplete':
          color = '#9B5094'
          break
        case 'closeout':
          color = '#67df91'
          break
        case 'initiation':
          color = '#b4b4b4'
          break
        default:
          color = '#b4b4b4'
      }
    } else {
      color = '#ff5b5b'
    }
    return color
  },
  // For calender (events are scheduled)
  events(state) {
    var target = []
    state.scheduledTasks.forEach(task => {
      let color = null
      switch (task.status.toLowerCase()) {
        case 'planning':
          color = '#f8da36'
          break
        case 'execution':
          color = '#2196f3'
          break
        case 'fieldcomplete':
          color = '#9B5094'
          break
        case 'closeout':
          color = '#67df91'
          break
        case 'initiation':
          color = '#b4b4b4'
          break
        default:
          color = '#b4b4b4'
      }
      // Add crews to tasks for calendar
      let crews = []
      let count = 0
      let name = ''
      for (let i = 0; i < task.crewTasks.length; i++) {
        if (crews.length > 0) {
          crews.push({ text: task.crewTasks[i].crew.id, value: task.crewTasks[i].crew })
          count++
        } else {
          crews.push({ text: task.crewTasks[i].crew.id, value: task.crewTasks[i].crew })
          name = `${task.crewTasks[i].crew.crewLead.firstName}`
        }
      }

      let extraCrews = ''
      if (count > 0) {
        extraCrews = `${count + 1} crews `
      } else if (count === 0 && name) {
        extraCrews = `${name}`
      } else {
        extraCrews = `Unassigned `
      }

      var nameForCalander = `${task.workOrder.workOrderNumber}-${task.taskNumber} `

      let flaggedMessage = ''
      switch (task.flagged) {
        case 'NONE':
          //Nothing
          break;
        case 'ATTN':
          flaggedMessage =' [A] '
          break;
        case 'PON':
          flaggedMessage = ' [P] '
          break;
        case 'BOTH':
          flaggedMessage = ' [A][P] '
          break;
        default:
          //Nothing
      }


      task.scheduledDays.forEach(s => {
        let crewName = extraCrews
        if (s.crew !== null) {
          crewName = s.crew.crewLead.firstName

        }

        if (s.start.slice(0, 10) != s.end.slice(0, 10)) {
          s.start = s.start.slice(0, 10)
          s.end = s.end.slice(0, 10)
        }


        let event = {
          name: flaggedMessage + nameForCalander + ' | ' + crewName,
          workOrderId: task.workOrderId,
          taskNumber: task.taskNumber,
          start: s.start,
          end: s.end,
          color: color,
          circuitNumber: task.circuitNumber,
          crews: crews,
          status: task.status,
          isd: task.isd.slice(0, 10),
          completionDate: task.completionDate.slice(0, 10),
          startDate: task.startDate.slice(0, 10),
          duration: task.duration,
          flag: task.flag,
          flagged: task.flagged,
          workOrder: task.workOrder,
          latitude: task.latitude,
          longitude: task.longitude,
          address: task.address,
          eso: task.eso,
          description: task.description,
          id: task.id,
          regionId: task.regionId,
          region: task.region,
          scheduledDays: task.scheduledDays,
          scheduledDay: s
        }

        if (s.crew !== null && (typeof state.searchObject.searchSubForeman !== 'undefined') && state.searchObject.searchSubForeman !== null) {
          if (s.crew.crewLeadId === state.searchObject.searchSubForeman) {
            target.push(event)
          }

        } else {
          target.push(event)
        }

      })


    })
    return target
  }
}
const actions = {
  // get single task
  async getTask ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.get(id)
      if (res) {
        await commit(types.REQUEST_GET_TASK_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASK_ERROR)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearTask ({ commit }, task) {
    commit(types.CLEAR_TASK)
  },
  // create & update
  async createTask ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      if (data.latitude === null || data.longitude === null) {
        delete data.latitude
        delete data.longitude
      }

      let res = await WorkOrderTask.create(data)
      if (res) {
        commit(types.REQUEST_CREATE_TASK_SUCCESS, res.data)
        dispatch('getTasks', state.searchObject)
        dispatch('loadISDList')
        dispatch('loadLocationList')
        return res
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_TASK_ERROR, err.message)
      return err.message
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateTask ({ commit, dispatch, state }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      if (data.startDate === null) { data.startDate = '0001-01-01' }
      if (data.completionDate === null) { data.completionDate = '0001-01-01' }
      delete data.planningChecklist
      delete data.scheduledDays
      let res = await WorkOrderTask.update(data.id, data)
      if (res) {
        commit(types.REQUEST_UPDATE_TASK_SUCCESS, res.data)
        dispatch('getTasks', state.searchObject)
        dispatch('loadStartDateList')
        dispatch('loadISDList')
        dispatch('loadLocationList')
      }
      return res
    } catch (err) {
      commit(types.REQUEST_UPDATE_TASK_ERROR, 'Error updating task ' + err.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  // Sub-update calls (add/remove crew && archive/restore)
  async addCrew ({ commit, dispatch, state }, crewTasks) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.addCrew(crewTasks)
      if (res) {
        commit(types.REQUEST_ADD_CREW_TO_TASK_SUCCESS, res.data)
        dispatch('getTasks', state.searchObject)
        dispatch('getTask', crewTasks.taskId)
      }
    } catch (error) {
      commit(types.REQUEST_ADD_CREW_TO_TASK_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async removeCrew({ commit, dispatch, state }, crewTasks) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.removeCrew(crewTasks)
      if (res) {
        commit(types.REQUEST_REMOVE_CREW_FROM_TASK_SUCCESS, res.data)
        dispatch('getTasks', state.searchObject)
        dispatch('getTask', crewTasks.taskId)
      }
    } catch (error) {
      commit(types.REQUEST_REMOVE_CREW_FROM_TASK_ERROR, error.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async archiveTask ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.archive(id)
      if (res) {
        commit(types.REQUEST_ARCHIVE_TASK_SUCCESS)
        dispatch('getTasks', state.searchObject)
      }
    } catch (err) {
      commit(types.REQUEST_ARCHIVE_TASK_ERROR, 'Error archiving task')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async restoreTask ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.restore(id)
      if (res) {
        commit(types.REQUEST_RESTORE_TASK_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_RESTORE_TASK_ERROR, 'Error restoring task')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  // filtering, sorting and get alls
  async getTasks ({ commit, state, dispatch }, searchObject) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {

      if (searchObject.searchReturn === null || searchObject.searchReturn === undefined || searchObject.searchReturn === {}) {
        let searchReturn = { listType: 'tasks' }
        searchObject.searchReturn = searchReturn
      } else {
        searchObject.searchReturn.listType = 'tasks'
      }
      searchObject.sortOrder = state.taskSort.sortOrder
      searchObject.isDesc = state.taskSort.isDesc
      console.log("Search Object")
      console.log(searchObject)
      let res = await WorkOrderTask.search(searchObject)
      console.log("Search Response")
      console.log(res)
      if (res) {
        commit('SET_MAP_TASKS_SUCCESS', res.data.taskLocationList)
        commit('REQUEST_GET_SEARCH_TASKS_SUCCESS', res.data)
        commit('SEARCH_OBJECT', searchObject)
      }
    } catch (error) {
      commit('REQUEST_GET_SEARCH_TASKS_ERROR', error)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadUnscheduledTasks ({ commit, dispatch }, searchUnsched) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      searchUnsched.searchReturn.listType = 'unscheduled'
      let res = await WorkOrderTask.search(searchUnsched)
      if (res) {
        commit(types.REQUEST_GET_UNSCHEDULED_TASKS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_UNSCHEDULED_TASKS_ERROR, 'Error getting unscheduled tasks')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadScheduledTasks ({ commit, dispatch, state }, searchSched) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      searchSched.searchReturn.listType = 'scheduled'

      if (searchSched.searchReturn.startPoint == null || searchSched.searchReturn.startPoint === '') {
        searchSched.searchReturn.startPoint = state.scheduledTaskPagination.startPoint
        searchSched.searchReturn.endPoint = state.scheduledTaskPagination.endPoint
      }

      let res = await WorkOrderTask.search(searchSched)
      if (res) {
        commit(types.REQUEST_GET_SCHEDULED_TASKS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_SCHEDULED_TASKS_ERROR, 'Error getting scheduled tasks')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadArchivedTasks ({ commit, dispatch }, searchObject) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      searchObject.searchReturn.listType = 'archived'

      let res = await WorkOrderTask.search(searchObject)
      if (res) {
        commit(types.REQUEST_GET_TASKS_ARCHIVED_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASKS_ARCHIVED_ERROR, 'Error getting archived tasks')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async toggleSortDirection ({ commit }, data) {
    commit(types.SET_SORT_DIRECTION, data)
  },
  async clearSort ({ commit }, data) {
    commit(types.CLEAR_SORT, data)
  },
  async loadLocationList ({ commit, dispatch }, match) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.getLocationList(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_TASK_LOCATION_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASK_LOCATION_LIST_ERROR, 'No locations were found')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadISDList ({ commit, dispatch }, match) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.getISDList(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_TASK_ISD_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASK_ISD_LIST_ERROR, 'No ISD dates were found')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadStartDateList ({ commit, dispatch }, match) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.getStartDateList(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_TASK_START_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASK_START_LIST_ERROR, 'No start dates were found')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadCPANumberList({ commit, dispatch }, match) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrderTask.getCPANumberList(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_TASK_CPA_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_TASK_CPA_LIST_ERROR, 'No cpa numbers were found')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getTaskLocationForMap ({ commit }) {
    try {
      let res = await WorkOrderTask.getTasksLocation()
      if (res) {
        commit(types.SET_MAP_TASKS_SUCCESS, res.data)
      }
    } catch (error) {
      commit(types.SET_MAP_TASKS_ERROR, error.message)
    }
  },
  async updateSearchObject ({ commit }, searchObject) {
    commit('SEARCH_OBJECT', searchObject)
  },
  async clearTasks ({ commit }) {
    await commit(types.CLEAR_TASKS)
  }
}

const mutations = {
  [types.REQUEST_GET_TASK_SUCCESS] (state, data) {
    state.task = data
    state.error = null
  },
  [types.REQUEST_GET_TASK_ERROR] (state, message) {
    state.task = null
    state.error = message
  },
  [types.CLEAR_TASK] (state) {
    state.task = null
  },
  [types.CLEAR_TASKS] (state) {
    state.tasks = []
    state.sortOrder = 'isd'
  },
  [types.REQUEST_CREATE_TASK_SUCCESS] (state, data) {
    state.error = null
    state.task = data
  },
  [types.REQUEST_CREATE_TASK_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_UPDATE_TASK_SUCCESS] (state, data) {
    state.task = data
    state.error = null
  },
  [types.REQUEST_UPDATE_TASK_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_ADD_CREW_TO_TASK_SUCCESS] (state, data) {
    state.error = null
  },
  [types.REQUEST_ADD_CREW_TO_TASK_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_REMOVE_CREW_FROM_TASK_SUCCESS] (state, data) {
    state.error = null
  },
  [types.REQUEST_REMOVE_CREW_FROM_TASK_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_ARCHIVE_TASK_SUCCESS] (state) {
    state.task = null
    state.error = null
  },
  [types.REQUEST_ARCHIVE_TASK_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_RESTORE_TASK_SUCCESS] (state, data) {
    state.task = data
    state.error = null
  },
  [types.REQUEST_RESTORE_TASK_ERROR] (state, message) {
    state.task = null
    state.error = message
  },
  [types.SEARCH_OBJECT](state, data) {
    state.searchObject = data
    state.searchObject.searchReturn = {}
  },
  [types.REQUEST_GET_SEARCH_TASKS_SUCCESS] (state, data) {
    if (data.pageIndex > 1) { // if past the first page append the task list with the additional tasks
      data.tasks.forEach(task => {
        state.tasks.push(task)
      })
    } else {
      state.tasks = data.tasks
    }
    state.taskPagination.pageIndex = data.pageIndex
    state.taskPagination.pageSize = data.pageSize
    state.taskPagination.count = data.totalCount

    //  set error to null
    state.error = null
  },
  [types.REQUEST_GET_SEARCH_TASKS_ERROR] (state, message) {
    state.tasks = []
    state.taskPagination = {}
    state.error = message
  },
  [types.REQUEST_GET_TASKS_ARCHIVED_SUCCESS] (state, data) {
    state.archivedTasks = data.tasks
    state.archivedTotal = data.archivedCount
    state.error = null
  },
  [types.REQUEST_GET_TASKS_ARCHIVED_ERROR] (state, message) {
    state.archivedTasks = []
    state.archivedTaskPagination.count = null
    state.archivedTaskPagination.pageIndex = null
    state.archivedTaskPagination.pageSize = null
    state.error = message
  },
  [types.REQUEST_GET_UNSCHEDULED_TASKS_SUCCESS] (state, data) {
    if (data.pageIndex > 1) { // if past the first page append the task list with the additional tasks
      data.tasks.forEach(task => {
        state.unscheduledTasks.push(task)
      })
    } else {
      state.unscheduledTasks = data.tasks
    }
    // pagination
    state.unscheduledTaskPagination.pageIndex = data.pageIndex
    state.unscheduledTaskPagination.pageSize = data.pageSize
    state.unscheduledTaskPagination.count = data.unscheduledCount

    // error to null
    state.error = null
  },
  [types.REQUEST_GET_UNSCHEDULED_TASKS_ERROR] (state, message) {
    state.unscheduledTasks = []
    state.unscheduledTaskPagination.count = null
    state.unscheduledTaskPagination.pageIndex = null
    state.unscheduledTaskPagination.pageSize = null
    state.error = message
  },
  [types.REQUEST_GET_SCHEDULED_TASKS_SUCCESS] (state, data) {
    state.scheduledTasks = data.tasks
    state.scheduledTaskPagination.startPoint = data.startPoint
    state.scheduledTaskPagination.endPoint = data.endPoint
    state.error = null
  },
  [types.REQUEST_GET_SCHEDULED_TASKS_ERROR] (state, message) {
    state.error = message
    state.scheduledTaskPagination.startPoint = ''
    state.scheduledTaskPagination.endPoint = ''
    state.scheduledTasks = []
  },
  [types.CLEAR_SORT] (state) { // set to defaults
    state.taskSort.sortOrder = 'isd'
    state.taskSort.isDesc = true
  },
  [types.SET_SORT_DIRECTION] (state, data) {
    state.taskSort = data
  },
  [types.REQUEST_GET_TASK_LOCATION_LIST_SUCCESS] (state, data) {
    state.error = null
    state.locations = data
  },
  [types.REQUEST_GET_TASK_LOCATION_LIST_ERROR] (state, message) {
    state.error = message
    state.locations = []
  },
  [types.REQUEST_GET_TASK_ISD_LIST_SUCCESS] (state, data) {
    state.error = null
    state.isdDates = data
  },
  [types.REQUEST_GET_TASK_ISD_LIST_ERROR] (state, message) {
    state.error = message
    state.isdDates = []
  },
  [types.REQUEST_GET_TASK_START_LIST_SUCCESS] (state, data) {
    state.error = null
    state.startDates = data
  },
  [types.REQUEST_GET_TASK_START_LIST_ERROR] (state, message) {
    state.error = message
    state.startDates = []
  },
  [types.REQUEST_GET_TASK_CPA_LIST_SUCCESS](state, data) {
    state.error = null
    state.cpaNumbers = data
  },
  [types.REQUEST_GET_TASK_CPA_LIST_ERROR](state, message) {
    state.error = message
    state.cpaNumbers = []
  },
  [types.SET_MAP_TASKS_SUCCESS] (state, tasks) {
    state.taskLocationList = tasks
    state.error = null
  },
  [types.SET_MAP_TASKS_ERROR] (state, message) {
    state.taskLocationList = null
    state.error = message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
